import { Paper } from '@trackman/web-shared-components';
import React from 'react';
import styled from 'styled-components';
import { EditLineupMenuWrapper } from '../../EditLineupMenu/EditLineupMenuStyles';

export const LineupListWrapper = styled.div`
  position: relative;
  .tagging-column {
    padding: 6px 5px !important;
    overflow-y: auto;
    height: 100%;
  }

  ${EditLineupMenuWrapper} {
    position: absolute;
    top: -2px;
    right: 0;
    cursor: pointer;
  }
`;

export const TaggingColumnWrapper = styled((props) => <Paper {...props} />)`
  display: flex;
  flex-direction: column;
`;
